import { ReactNode } from "react";
import styles from './Messages.module.scss'
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";

export type MessageProps = {
  show?: boolean
  children?: ReactNode
  title?: ReactNode
  subtitle?: ReactNode
  type?: 'message' | 'error' | 'success' | 'warning'
  iconRound?: boolean
  icon?: IconDefinition
  iconProps?: Omit<FontAwesomeIconProps, 'icon'>
};
export default (
  {
    show,
    title,
    subtitle,
    icon,
    iconRound,
    iconProps,
    type = 'message',
    children
  }: MessageProps) => {

  if (show !== undefined && !show) {
    return <></>
  }
  const styleMap = {
    message: styles.message,
    error: styles.error,
    success: styles.success,
    warning: styles.warning,
  }
  return <div className={[styles.container, styleMap[type]].join(' ')}>

    {icon &&
      <div className={[styles.icon, iconRound && styles.round].join(' ')}><span><FontAwesomeIcon
        icon={icon} {...iconProps} /></span>
      </div>}
    <div className={styles.texts}>
      {children}
      {title && <div className={styles.title}>{title}</div>}
      {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
    </div>
  </div>
}
